export default __webpack_public_path__ + "static/GT-Super-Display-Bold-Italic-ab8093c125cb2afac5fe62db2ad6697a.woff2";